<template>
  <toggle-button-group :options="refTimeOptions" @change="handleChange" />
</template>

<script>
import toggleButtonGroup from '../../../toggleButton/toggleButtonGroup.vue';

export default {
  name: 'RidershipReferenceTimeToggle',
  components: { toggleButtonGroup },
  props: {
    selectedRefTime: {
      type: String,
      default: 'firstStopDeparture',
    },
  },
  computed: {
    refTimes() {
      return [
        { value: 'firstStopDeparture', label: this.$t('flexigo.ridership.byFirstStopDeparture') },
        { value: 'lastStopArrival', label: this.$t('flexigo.ridership.byLastStopArrival') },
      ];
    },
    refTimeOptions() {
      return this.refTimes.map(({ label, value }) => ({
        label,
        selected: value === this.selectedRefTime,
      }));
    },
  },
  methods: {
    handleChange({ index }) {
      this.$emit('change', this.refTimes[index].value);
    },
  },
};
</script>
